import { z } from "zod";

// LLM prompt surfaces whose text is externalized to the DB (prompt_bundles).
// Order is append-only: `prompt_surface` is a pg enum, and Postgres only
// supports adding values. "yeet-agent" is the yeet audit agent's system prompt;
// "yeet-canonicalizer" is the run-level problem-key canonicalizer's.
export const PROMPT_SURFACES = [
  "yeet-agent",
  "yeet-canonicalizer",
  "agentic-social-analyse",
] as const;
export const PROMPT_SURFACE = {
  YEET_AGENT: "yeet-agent",
  YEET_CANONICALIZER: "yeet-canonicalizer",
  SOCIAL_ANALYSE: "agentic-social-analyse",
} as const satisfies Record<string, PromptSurface>;
export const PromptSurfaceSchema = z.enum(PROMPT_SURFACES);
export type PromptSurface = z.infer<typeof PromptSurfaceSchema>;
